import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, UserPlus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { BRAND_LOGO } from "@/components/SEO";
import SEO from "@/components/SEO";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await register(form);
      toast.success(`Welcome, ${user.name}!`);
      nav("/account");
    } catch (err) { toast.error(apiError(err)); }
    finally { setLoading(false); }
  };

  const input = "w-full rounded-2xl border border-gray-200 px-4 py-3.5 text-navy outline-none focus:border-brandorange";
  return (
    <>
      <SEO title="Register | Happy Holidays Wale" description="Create your Happy Holidays Wale account." />
      <div className="flex min-h-[80vh] items-center justify-center px-4 py-12">
        <div className="w-full max-w-md rounded-3xl border border-gray-100 bg-white p-8 card-soft">
          <img src={BRAND_LOGO} alt="Happy Holidays Wale" className="mx-auto mb-6 h-12" />
          <h1 className="text-center font-display text-3xl font-bold text-navy">Create Account</h1>
          <p className="mt-1 text-center text-sm text-gray-500">Join us to track your dream holidays</p>
          <form onSubmit={submit} className="mt-7 space-y-4" data-testid="register-form">
            <input data-testid="register-name" required className={input} placeholder="Full name" value={form.name} onChange={set("name")} />
            <input data-testid="register-email" type="email" required className={input} placeholder="Email address" value={form.email} onChange={set("email")} />
            <input data-testid="register-phone" className={input} placeholder="Phone number" value={form.phone} onChange={set("phone")} />
            <input data-testid="register-password" type="password" required minLength={6} className={input} placeholder="Password (min 6 chars)" value={form.password} onChange={set("password")} />
            <button data-testid="register-submit" disabled={loading} className="btn-gradient flex w-full items-center justify-center gap-2 rounded-full py-3.5 font-bold disabled:opacity-70">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><UserPlus className="h-4 w-4" /> Register</>}
            </button>
          </form>
          <p className="mt-5 text-center text-sm text-gray-500">Already have an account? <Link to="/login" className="font-semibold text-brandorange">Login</Link></p>
        </div>
      </div>
    </>
  );
}
